export enum ConnectionViewType {
  Settings = 'settings',
  ConfigurableResources = 'configurable-resources',
  CustomMapping = 'custom-mapping',
}
